import { CommonKeyMapping } from 'models/platforms/commonKeyMappings';
import { OneTrustRemoteKeys } from 'types/oneTrust';

const MandatoryKeyMapping = {
  37: 'Left',
  38: 'Up',
  39: 'Right',
  40: 'Down',
  13: 'Enter',
  27: 'Back', // X1 fires this on Back

  8: 'Back', // Flex fires this on Back
  69: 'Exit', // Flex's Exit button
};

// Different amongst remotes
const AssortedComcastKeyMapping = {
  179: 'MediaPlayPause',
  227: 'MediaRewind',
  228: 'MediaFastForward',
};

export const ComcastKeyMapping = {
  ...CommonKeyMapping,
  ...MandatoryKeyMapping,
  ...AssortedComcastKeyMapping,
};
